import { LinkWithTitle } from '@/components/links';
import { BOTTLE_GIRL_BOY_TITLE } from '@/pages/add-ons/bottle-girl-boy';
import { CUSTOM_SETLIST_DJ_TITLE } from '@/pages/add-ons/custom-setlist-dj';
import { PROFESSIONAL_PHOTOGRAPHER_TITLE } from '@/pages/add-ons/professional-photographer';

export const AddOnsList = () => {
  return (
    <>
      <li>
        <LinkWithTitle to="/add-ons/bottle-girl-boy">
          {BOTTLE_GIRL_BOY_TITLE}
        </LinkWithTitle>
      </li>
      <li>
        <LinkWithTitle to="/add-ons/custom-setlist-dj">
          {CUSTOM_SETLIST_DJ_TITLE}
        </LinkWithTitle>
      </li>
      <li>
        <LinkWithTitle to="/add-ons/professional-photographer">
          {PROFESSIONAL_PHOTOGRAPHER_TITLE}
        </LinkWithTitle>
      </li>
    </>
  );
};
